import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Cell, Logo, useStaticState } from '@phishtool/ui';
import Navigation from './navigation';
import MobileNavigationToggle from './navigation/mobile-toggle';
import { StyledMainHeaderWrapper, StyledMainHeaderNavigationWrapper, StyledLogoWrapper, StyledDemoButton, } from './styled';
const MainHeader = () => {
    const history = useHistory();
    const [staticData] = useStaticState();
    const [isNavigationOpen, setIsNavigationOpen] = useState(false);
    useEffect(() => {
        const removeListener = history.listen(() => {
            setIsNavigationOpen(false);
        });
        return () => {
            removeListener();
        };
    }, []);
    return (_jsx(StyledMainHeaderWrapper, { children: _jsxs(Grid, { children: [_jsx(Cell, Object.assign({ start: 1, end: 3 }, { children: _jsx(StyledLogoWrapper, { children: _jsx(Logo, {}) }) })), _jsx(Cell, Object.assign({ start: 3, end: 13 }, { children: _jsxs(StyledMainHeaderNavigationWrapper, { children: [_jsx(MobileNavigationToggle, { isOpen: isNavigationOpen, setIsOpen: setIsNavigationOpen }), _jsx(Navigation, { isOpen: isNavigationOpen }), _jsx(StyledDemoButton, Object.assign({ buttonTheme: "success", to: `${staticData === null || staticData === void 0 ? void 0 : staticData.env.APP_HOST}/sign-up/enterprise`, autoWidth: true }, { children: "Get a demo" }))] }) }))] }) }));
};
export default MainHeader;
